<template>
  <div class="animated fadeIn">
    <!-- 성적 / 수상 증명 -->
    <b-row align-h="start">
      <b-col md="12">
        <b-row v-if="!freezing">
          <b-col md="10">
            <b-form-group
              name="fileCertSet"
              label="서밋 신청자 서류 제출(Certificates for Summit)"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-form-file
                ref="fileCert"
                v-model="pdfCert"
                no-drop
                name="pdf"
                multiple
                :disabled="pdfCertDisabled || freezing"
                accept="application/pdf"
                :placeholder="schlsType === 'DONATED' ? '지정 기탁일때는 제출 불필요합니다(No certificates for donated)' : '성적표, 상장등을 꼭 PDF 파일로 제출해주세요(Upload pdf files for certificates)'"
                @input="inputCert()"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            class="text-left"
          >
            <b-form-group
              label="리셋"
              :invalid-feedback="''"
              :valid-feedback="''"
            >
              <b-button
                :disabled="pdfCertDisabled"
                size="md"
                variant="warning"
                @click="clearFiles(true)"
              >
                Reset
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="freezing">
          <b-col
            md="12"
            class="text-left"
          >
            <hr>
            <h6>서밋 신청용 첨부 파일 리스트:</h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(f, idx) in pdfCertAll"
          :key="idx"
        >
          <b-col
            md="11"
            class="text-left"
          >
            <a :href="serverUri + '/cdn/pdf?id=' + f.id + '&email=' + email">
              {{ f.name }}
            </a>
          </b-col>
          <b-col
            v-if="!freezing"
            md="1"
            class="text-right"
          >
            <b-button
              :disabled="freezing"
              size="sm"
              variant="danger"
              @click="delCert(idx)"
            >
              X
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'ApplyCert',
  props: {
    email: {
      type: String,
      required: true
    },
    applyId: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    schlsType: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      serverUri: api.serverURI,
      pdfCert: [],
      pdfCertAll: [],
      pdfCertDisabled: false
    }
  },
  computed: {
    freezing () {
      return (this.readOnly)
    }
  },
  watch: {
    schlsType: function (newVal, oldVal) { // watch it
      if (this.schlsType === 'DONATED') {
        this.clearFiles(false)
        this.pdfCertDisabled = true
      } else if (this.schlsType === 'TOP') {
        this.clearFiles(false)
        this.pdfCertDisabled = false
      }
    }
  },
  mounted () {
    this.getApplyCerts()
  },
  methods: {
    setFreezing (val) {
      this.readOnly = val
    },
    getApplyCerts () {
      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('get', '/apply/check?applyId=' + this.applyId + '&info=1&ic=certs')
        .then(response => {
          var data = response.data
          if (data.check !== 0) {
            this.parseApply(data)
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    parseApply (data) {
      this.pdfCertAll = data.certs
      this.updateCertAll(false)
    },
    clearFiles (tellToParent) {
      if (this.$refs.fileCert) {
        this.$refs.fileCert.reset()
        this.pdfCert = []
        this.pdfCertAll = []
        this.updateCertAll(tellToParent)
      }
    },
    delCert (target) {
      this.pdfCertAll.splice(target, 1)
      this.updateCertAll(true)
      if (this.pdfCertAll.length === 0) {
        this.clearFiles(true)
      }
    },
    /* 변경되자마자 */
    inputCert () {
      this.pdfCert.forEach(f => {
        var dup = false
        this.pdfCertAll.forEach(fa => {
          if (fa.name === f.name) {
            dup = true
          }
        })
        if (!dup && f.type.includes('pdf')) {
          var formData = new FormData()
          formData.append('email', this.email)
          formData.append('term', api.currentTerm())
          formData.append('pdf', f, f.name)
          this.fileSave(formData, f.name)
        }
      })
    },
    fileSave (formData, name) {
      api.fileUpload(formData)
        .then(x => {
          var uploadedFiles = [].concat(x)
          this.pdfCertAll.push({ 'name': name, 'id': uploadedFiles[0].id })
          this.updateCertAll(false)
        })
        .catch(err => {
          alert('pdf 등록 실패')
          alert(err.response)
        })
    },
    updateCertAll (toTop) {
      this.$emit('updateCertAll', this.pdfCertAll, toTop)
    }
  }
}
</script>

<style>
</style>
